import { Heading3, Text } from '@lightspeed/flame/Text';
import { Box, Flex } from '@lightspeed/flame/Core';
import { LabelRequired } from '../custom/LabelRequired';
import { Autocomplete } from '../fields';
import { useTranslation } from 'react-i18next';
import useConnectionMode from '../../hooks/useConnectionMode';
import useAccounts from '../../hooks/useAccounts';
import useIsInputsOnlyLayout from '../../hooks/useIsInputsOnlyLayout';

export const MapTips = () => {
  const [, softwareName] = useConnectionMode();
  const [isLoading, accountsList] = useAccounts('tips');
  const { t } = useTranslation();
  const [isInputsOnlyLayout] = useIsInputsOnlyLayout();

  return <Box padding="0.75rem">
    <Heading3 mb="0.375rem">{t('Tips')}</Heading3>
    <Text color="gray-600" mb="1.5rem" mr="3.25rem" size="small">
      {t('MapTipsDesc', { swName: softwareName })}
    </Text>
    <Flex>
      <Box width="49%" pr="1.1rem">
        <LabelRequired htmlFor="Tips">
          {
            t(isInputsOnlyLayout ? 'Enter tips account' : 'Select a tips account')
          } 
        </LabelRequired>
        <Autocomplete
          isLoadingOptions={isLoading}
          id="Tips"
          name="Tips"
          options={accountsList}
          placeholder={
            t(isInputsOnlyLayout ? 'Enter tips account' : 'Select an account')
          }
        />
      </Box>
    </Flex>
  </Box>;
};
